import React from "react";
import "./ProductSpine.css";

import displayIcon from "../../../../assets/images/productSpine/display-icon.png";
import videoIcon from "../../../../assets/images/productSpine/video-icon.png";
import tvIcon from "../../../../assets/images/productSpine/tv-icon.png";
import audioIcon from "../../../../assets/images/productSpine/audio-icon.png";
import nativeIcon from "../../../../assets/images/productSpine/native-icon.png";

import baiDu from "../../../../assets/images/productSpine/baiDu.png";
import googleAds from "../../../../assets/images/productSpine/googleAds.png";
import yahooDsp from "../../../../assets/images/productSpine/yahooDsp.png";
import theTradeDesk from "../../../../assets/images/productSpine/theTradeDesk.png";
import googleDisplayVideo from "../../../../assets/images/productSpine/googleDisplayVideo.png";
import weChat from "../../../../assets/images/productSpine/weChat.png";
import amazonAds from "../../../../assets/images/productSpine/amazonAds.png";

import comscore from "../../../../assets/images/productSpine/comscore.png";
import vividata from "../../../../assets/images/productSpine/vividata.png";
import nielsen from "../../../../assets/images/productSpine/nielsen.png";
import similarWeb from "../../../../assets/images/productSpine/similarWeb.png";
import statica from "../../../../assets/images/productSpine/statica.png";
import staticsCanada from "../../../../assets/images/productSpine/staticsCanada.png";
import ias from "../../../../assets/images/productSpine/IAS.png";
import lucid from "../../../../assets/images/productSpine/Lucid.png";

const INVENTORY_ITEMS = [
    { icon: displayIcon, title: "Display", description: "Banner and rich media ads across websites and apps." },
    { icon: videoIcon, title: "Video", description: "Engaging video content across digital platforms." },
    { icon: tvIcon, title: "Connected TV", description: "Premium video ads on streaming services." },
    { icon: audioIcon, title: "Audio", description: "Targeted ads on music and podcast platforms." },
    { icon: nativeIcon, title: "Native", description: "Seamless ads that match the look and feel of content." },
];

const PLATFORM_BADGES = [
    { label: "Direct Premium Publishers", filled: true },
    { label: "Direct Premium Apps", filled: true },
    { label: "PubMatic" },
    { label: "Equativ" },
    { label: "Index Exchange" },
    { label: "Criteo" },
    { label: "LoopMe" },
    { label: "Magnite" },
    { label: "Google Curation" },
    { label: "OpenX" },
    { label: "Nexxen" },
];

const SCALE_KPIS = [
    { value: "1BN+", label: "Impressions", description: "Delivered across platforms." },
    { value: "100+", label: "Brands", description: "Global brands served." },
    { value: "1BN+", label: "Ads", description: "Placements managed at scale." },
];

const IDENTITY_NODES = [
    { logo: baiDu, name: "Baidu" },
    { logo: googleAds, name: "Google Ads" },
    { logo: yahooDsp, name: "Yahoo DSP" },
    { logo: theTradeDesk, name: "The Trade Desk" },
    { logo: googleDisplayVideo, name: "DV360" },
    { logo: weChat, name: "WeChat" },
    { logo: amazonAds, name: "Amazon Ads" },
];

const TARGETING_COLUMNS = [
    { title: "Buyer Personas", description: "Demographics, interests, and behaviors that define your audience." },
    { title: "Content Categories", description: "Contextual categories your target audience typically consumes." },
    { title: "High-Intent Keywords", description: "Search terms and performance marketing indicators." },
];

const MEASUREMENT_PARTNERS = [comscore, vividata, nielsen, similarWeb, statica, staticsCanada];

const PRECISION_FEATURES = [
    {
        icon: "fa-shield-halved",
        title: "Brand Safety",
        description: "Ensuring ads appear in appropriate contexts that protect brand reputation.",
    },
    {
        icon: "fa-bullseye",
        title: "Segmental Targeting",
        description: "Precise audience segmentation for maximum relevance.",
    },
    {
        icon: "fa-bag-shopping",
        title: "Buying Intent",
        description: "Matching from Awareness to Performance across the purchase funnel.",
    },
];

const VERIFICATION_PARTNERS = [
    { logo: nielsen, name: "Nielsen" },
    { logo: ias, name: "IAS" },
    { logo: lucid, name: "Lucid" },
];

const ProductSpine = () => {
    return (
        <div className="ps-page">
            {/* ---------- Hero + inventory ---------- */}
            <section className="ps-hero">
                <h1 className="ps-h1">
                    One connected framework for <em>every</em> audience, format &amp; platform.
                </h1>
                <p className="ps-lead">
                    A comprehensive digital advertising infrastructure supporting diverse inventory types across
                    premium platforms — serving 100s of brands with billions of impressions.
                </p>

                <div className="ps-stat-pills">
                    <div className="ps-stat-pill">
                        <b>100s of</b>
                        <span>Brands Served</span>
                    </div>
                    <div className="ps-stat-pill">
                        <b>Billions</b>
                        <span>of Impressions Delivered</span>
                    </div>
                    <div className="ps-stat-pill alt">
                        <b>5</b>
                        <span>Inventory Types</span>
                    </div>
                </div>

                <div className="ps-inventory-grid">
                    {INVENTORY_ITEMS.map((item) => (
                        <div className="ps-inventory-card" key={item.title}>
                            <div className="ps-inventory-icon">
                                <img src={item.icon} alt="" />
                            </div>
                            <h4>{item.title}</h4>
                            <p>{item.description}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ---------- Premium platform integration ---------- */}
            <section className="ps-section ps-section-alt">
                <div className="ps-sec-head">
                    <div>
                        <span className="ps-sec-tag">Supply</span>
                        <h2>Premium platform integration</h2>
                    </div>
                    <p className="ps-sec-desc">
                        Our framework connects with top-tier platforms to ensure quality ad placements and maximum
                        reach across the digital ecosystem.
                    </p>
                </div>

                <div className="ps-cols">
                    <div className="ps-badge-row">
                        {PLATFORM_BADGES.map((b) => (
                            <span key={b.label} className={`ps-badge ${b.filled ? "" : "outline"}`}>
                                {b.label}
                            </span>
                        ))}
                    </div>
                    <div>
                        <span className="ps-sec-tag ps-kpi-tag">Impressive scale &amp; volume</span>
                        <div className="ps-kpi-grid">
                            {SCALE_KPIS.map((kpi, i) => (
                                <div className={`ps-kpi-card c${i + 1}`} key={kpi.label}>
                                    <b>{kpi.value}</b>
                                    <span>{kpi.label}</span>
                                    <p>{kpi.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* ---------- User identity spine ---------- */}
            <section className="ps-section">
                <div className="ps-sec-head">
                    <div>
                        <span className="ps-sec-tag">Identity · Buy Side</span>
                        <h2>User Identity Spine</h2>
                    </div>
                    <p className="ps-sec-desc">
                        The core of our audience targeting — a holistic view of user behavior built from direct
                        interactions and first-party device data, ensuring accuracy for highly targeted campaigns.
                    </p>
                </div>

                <div className="ps-spine-wrap">
                    <div className="ps-spine-track" />
                    <div className="ps-node-row">
                        {IDENTITY_NODES.map((node) => (
                            <div className="ps-node" key={node.name}>
                                <div className="ps-node-dot">
                                    <img src={node.logo} alt={node.name} />
                                </div>
                                <span>{node.name}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ---------- Contextual targeting ---------- */}
            <section className="ps-section ps-section-alt">
                <div className="ps-sec-head">
                    <div>
                        <span className="ps-sec-tag">Signal Layer</span>
                        <h2>Contextual targeting</h2>
                    </div>
                    <p className="ps-sec-desc">
                        Our engine analyzes content by tone, category (4,000+ classifications, extendable) and
                        purchase intent — aligning delivery with campaign objectives.
                    </p>
                </div>

                <div className="ps-trio">
                    {TARGETING_COLUMNS.map((col) => (
                        <div className="ps-trio-card" key={col.title}>
                            <h4>{col.title}</h4>
                            <p>{col.description}</p>
                        </div>
                    ))}
                </div>

                <div className="ps-partner-panel">
                    <span className="ps-sec-tag ps-kpi-tag">Measurement &amp; data partners</span>
                    <div className="ps-logo-row">
                        {MEASUREMENT_PARTNERS.map((logo, i) => (
                            <span className="ps-logo-chip" key={i}>
                                <img src={logo} alt="" />
                            </span>
                        ))}
                    </div>
                </div>
            </section>

            {/* ---------- Safety & brand lift ---------- */}
            <section className="ps-section">
                <div className="ps-sec-head">
                    <div>
                        <span className="ps-sec-tag">Trust Layer</span>
                        <h2>Safety &amp; brand lift</h2>
                    </div>
                    <p className="ps-sec-desc">
                        Precision matching — from awareness to performance — with brand safety enforced at every
                        step of delivery.
                    </p>
                </div>

                <div className="ps-cols">
                    <div className="ps-prec-list">
                        {PRECISION_FEATURES.map((f) => (
                            <div className="ps-prec-item" key={f.title}>
                                <div className="ps-prec-icon">
                                    <i className={`fa-solid ${f.icon}`}></i>
                                </div>
                                <div>
                                    <h4>{f.title}</h4>
                                    <p>{f.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="ps-partner-panel">
                        <span className="ps-sec-tag ps-kpi-tag">Verification partners</span>
                        <div className="ps-logo-row">
                            {VERIFICATION_PARTNERS.map((p) => (
                                <span className="ps-logo-chip" key={p.name}>
                                    <img src={p.logo} alt={p.name} />
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ProductSpine;
